import { useEffect } from "react"
import { TShowFormContentDialog } from "./types"
import { CircularProgress, DialogHandler, TagsFactory } from "@cakemail-org/ui-components-v2"
import { useTranslation } from "react-i18next"


export function showFormContentDialog({ resolve, reject, args, getContentContext }: TShowFormContentDialog) {
    DialogHandler.show({
        content: <FormContentDialog resolve={resolve} reject={reject} args={args} getContentContext={getContentContext} />,
    })
}

export function FormContentDialog({ resolve, reject, args, getContentContext }: TShowFormContentDialog) {
    const { t } = useTranslation()

    useEffect(() => {
        reject("")
    }, [])

    async function fetchCustomAttributes() {
        const context = getContentContext()
        const list = context.list
        if (list) {
            return list.getAttributes({ perPage: 200 }).then((attributes) => {
                return attributes.data
            }).catch((error) => {
                return []
            })
        }

        return []
    }
    async function fetchInterests() {
        const context = getContentContext()
        const list = context.list
        if (list) {
            return list.getInterests({ perPage: 200 }).then((interests) => {
                return interests.data
            }).catch((error) => {
                return []
            })
        }
        return []
    }
    async function fetchTags() {
        return TagsFactory.list({ perPage: 200 }).then((tags) => {
            return tags.data
        }).catch((error) => {
            return []
        })
    }

    return <CircularProgress variant="indeterminate" />
}